import React, { useState, useCallback, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import classnames from 'classnames'

import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'

import Window from 'components/dialog/Window'
import ColorKey from './ColorKey'
import colors from './colors'
import colorUtils from '../../utils/color'

const getColorStyle = color => ({
  backgroundColor: colors[color],
})

const useStyles = makeStyles(theme => {
  return {
    cell: {
      padding: theme.spacing(2),
    },
    textField: {
      width: '100%',
    },
    color: {
      width: '50px',
      height: '50px',
      border: '1px solid #000',
    },
    red: getColorStyle('red'),
    amber: getColorStyle('amber'),
    green: getColorStyle('green'),
  }
})

const ItemEditor = ({
  item,
  settings,
  onClose,
  onSubmit,
}) => {
  const [ text, setText ] = useState('')
  const [ threshold, setThreshold ] = useState(0)

  const classes = useStyles({
    color,
  })

  useEffect(() => {
    setText(item.text || '')
    setThreshold(item.threshold || 0)
  }, [
    item,
  ])

  const onSave = useCallback(() => {
    if(!onSubmit) return
    onSubmit({
      text,
      threshold: parseInt(threshold),
    })
  }, [
    text,
    threshold,
  ])

  const hasError = isNaN(parseInt(threshold))

  const color = colorUtils.getColor({
    settings,
    threshold,
  })

  return (
    <Window
      open
      size="md"
      title="Item Details"
      cancelTitle="Cancel"
      submitTitle="Save"
      withCancel
      disabled={ hasError }
      onCancel={ onClose }
      onSubmit={ onSave }
    >
      <Grid container>
        <Grid item xs={ 4 } className={ classes.cell }>
          <TextField
            id="item-threshold"
            label="Threshold"
            type="number"
            variant="outlined"
            value={ threshold }
            className={ classes.textField }
            onChange={ (e) => setThreshold(e.target.value) }
          />
        </Grid>
        <Grid item xs={ 4 } className={ classes.cell }>
          <div className={ classnames(classes.color, classes[color]) }>

          </div>
        </Grid>
        <Grid item xs={ 4 } className={ classes.cell }>
          <ColorKey settings={ settings } />
        </Grid>
        <Grid item xs={ 12 } className={ classes.cell }>
          <TextField
            id="item-text"
            label="Text"
            multiline
            rows="5"
            variant="outlined"
            value={ text }
            className={ classes.textField }
            onChange={ (e) => setText(e.target.value) }
          />
        </Grid>
      </Grid>
    </Window>
  )
}

export default ItemEditor